module.exports = __webpack_public_path__ + "img/big_11B25_orange.0f152b92.png";